import React from 'react';
import { SelectValidator } from 'react-material-ui-form-validator';

import { usePageStore } from '@client/store/pageStore/context/pageContext';
import i18n from '@client/utils/i18n';
import { Grid, MenuItem, Stack } from '@mui/material';

const ResolutionSelector = () => {
    const {
        pageState: { formData },
        pageActions
    } = usePageStore();

    function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
        pageActions.formData.updateFormItem({ resolution: event.target.value });
    }

    return (
        <Grid item xs={12}>
            {formData.readOnly ? (
                <span>
                    {i18n('resolution')}: {i18n('X_bit', formData.resolution as number)}
                </span>
            ) : (
                <Stack direction="row" alignItems="center" spacing={2}>
                    <span className="MuiOutlinedInput-input" style={{ display: 'inline-block' }}>
                        {i18n('resolution')}:
                    </span>
                    <SelectValidator
                        onChange={handleChange}
                        value={formData.resolution}
                        variant="outlined"
                        name="resolution"
                        validators={['checkChannelConflict']}
                        errorMessages={['']}
                    >
                        <MenuItem value={1}>1</MenuItem>
                        <MenuItem value={8}>8</MenuItem>
                        {/* <MenuItem value={16}>16</MenuItem>*/}
                        {/* <MenuItem value={24}>24</MenuItem>*/}
                        {/* <MenuItem value={32}>32</MenuItem>*/}
                    </SelectValidator>
                    <span className="MuiOutlinedInput-input" style={{ display: 'inline-block' }}>
                        {i18n('bit')}
                    </span>
                </Stack>
            )}
        </Grid>
    );
};

export default ResolutionSelector;
